module.exports = __webpack_public_path__ + "static/img/css.5b7eaccc.png";